import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 6DF419CE-770C-4662-8681-5D8ADE9C789E
 * name moon-waxing-gibbous
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/moon-waxing-gibbous.svg
 * tags
 * - Weather 
 */
export const MoonWaxingGibbousIcon = createSvgIcon(<><path d="M6 12C6 7.5 7.93 3.26 12 2A10 10 0 0 1 12 22C7.93 20.74 6 16.5 6 12Z" /></>, 'MoonWaxingGibbousIcon');
export default MoonWaxingGibbousIcon